// Mock event data — vertical poster format
export const events = [
  {
    id: "evt-prague-dec",
    title: "Seoul Night · Prague",
    category: "K-POP",
    date: "2025-12-20",
    time: "22:00",
    dateLabel: { en: "DEC 20", cz: "20. PRO" },
    city: "Prague",
    venue: "Roxy",
    address: "Dlouhá 33, 110 00 Praha 1",
    image:
      "https://images.unsplash.com/photo-1583244532610-2a234e7c3eca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-bratislava-jan",
    title: "K-Wave · Bratislava",
    category: "K-POP",
    date: "2026-01-10",
    time: "22:00",
    dateLabel: { en: "JAN 10", cz: "10. LED" },
    city: "Bratislava",
    venue: "Subclub",
    address: "Nábrežie arm. gen. L. Svobodu, 811 02 Bratislava",
    image:
      "https://images.unsplash.com/photo-1541126274323-dbac58d14741?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxkaiUyMGNsdWIlMjBuaWdodCUyMHBvc3RlciUyMHN0eWxlfGVufDB8fHx8MTc4MTEyMjE1MXww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-brno-jan",
    title: "Neon Seoul · Brno",
    category: "K-POP",
    date: "2026-01-24",
    time: "22:00",
    dateLabel: { en: "JAN 24", cz: "24. LED" },
    city: "Brno",
    venue: "Fléda",
    address: "Štefánikova 24, 602 00 Brno",
    image:
      "https://images.unsplash.com/photo-1767661667474-4f2a197c9a51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: true,
  },
  {
    id: "evt-prague-feb",
    title: "Hallyu Fever · Prague",
    category: "K-POP",
    date: "2026-02-14",
    time: "22:00",
    dateLabel: { en: "FEB 14", cz: "14. ÚNO" },
    city: "Prague",
    venue: "Cross Club",
    address: "Plynární 23, 170 00 Praha 7",
    image:
      "https://images.unsplash.com/photo-1716969283310-51c36a9484ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-bratislava-mar",
    title: "Idol Riot · Bratislava",
    category: "K-POP",
    date: "2026-03-07",
    time: "22:00",
    dateLabel: { en: "MAR 07", cz: "07. BŘE" },
    city: "Bratislava",
    venue: "MMC",
    address: "Bajkalská 25/A, 821 01 Bratislava",
    image:
      "https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-brno-mar",
    title: "Maknae Line · Brno",
    category: "K-POP",
    date: "2026-03-21",
    time: "22:00",
    dateLabel: { en: "MAR 21", cz: "21. BŘE" },
    city: "Brno",
    venue: "Mersey Club",
    address: "Minská 15, 616 00 Brno",
    image:
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-prague-jun",
    title: "Seoul Summer · Prague",
    category: "K-POP",
    date: "2026-06-13",
    time: "22:00",
    dateLabel: { en: "JUN 13", cz: "13. ČVN" },
    city: "Prague",
    venue: "Roxy",
    address: "Dlouhá 33, 110 00 Praha 1",
    image:
      "https://images.unsplash.com/photo-1502872364588-894d7d6ddfab?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-brno-jun",
    title: "Neon Heatwave · Brno",
    category: "K-POP",
    date: "2026-06-27",
    time: "22:00",
    dateLabel: { en: "JUN 27", cz: "27. ČVN" },
    city: "Brno",
    venue: "Fléda",
    address: "Štefánikova 24, 602 00 Brno",
    image:
      "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-bratislava-jul",
    title: "K-Wave Open Air · Bratislava",
    category: "K-POP",
    date: "2026-07-11",
    time: "20:00",
    dateLabel: { en: "JUL 11", cz: "11. ČVC" },
    city: "Bratislava",
    venue: "Subclub",
    address: "Nábrežie arm. gen. L. Svobodu, 811 02 Bratislava",
    image:
      "https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
  {
    id: "evt-prague-jul",
    title: "Idol Riot · Prague",
    category: "K-POP",
    date: "2026-07-25",
    time: "22:00",
    dateLabel: { en: "JUL 25", cz: "25. ČVC" },
    city: "Prague",
    venue: "Cross Club",
    address: "Plynární 23, 170 00 Praha 7",
    image:
      "https://images.unsplash.com/photo-1583244532610-2a234e7c3eca?crop=entropy&cs=srgb&fm=jpg&w=900&q=85",
    ticketUrl: "https://goout.net",
    soldOut: false,
  },
];

export const galleryImages = [
  "https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwyfHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHw0fHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwzfHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1502872364588-894d7d6ddfab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTF8MHwxfHNlYXJjaHwxfHxrcG9wJTIwY2x1YiUyMG5pZ2h0JTIwbmVvbiUyMGNyb3dkfGVufDB8fHx8MTc4MTEyMjEzOHww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1583244532610-2a234e7c3eca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1716969283310-51c36a9484ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1541126274323-dbac58d14741?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MDV8MHwxfHNlYXJjaHwyfHxkaiUyMGNsdWIlMjBuaWdodCUyMHBvc3RlciUyMHN0eWxlfGVufDB8fHx8MTc4MTEyMjE1MXww&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1767661667474-4f2a197c9a51?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHw0fHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
];

export const cities = [
  {
    name: "Prague",
    label: { en: "Prague", cz: "Praha" },
    image:
      "https://images.pexels.com/photos/10721615/pexels-photo-10721615.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    venues: 4,
    tagline: { en: "Where it started.", cz: "Tady to začalo." },
  },
  {
    name: "Brno",
    label: { en: "Brno", cz: "Brno" },
    image:
      "https://images.pexels.com/photos/14355784/pexels-photo-14355784.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    venues: 2,
    tagline: { en: "Loud underground.", cz: "Hlasitý underground." },
  },
  {
    name: "Bratislava",
    label: { en: "Bratislava", cz: "Bratislava" },
    image:
      "https://images.unsplash.com/photo-1622884589148-18b8acf1cd37?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwzfHxicmF0aXNsYXZhJTIwY2l0eSUyMG5pZ2h0fGVufDB8fHx8MTc4MTEyMjE1MXww&ixlib=rb-4.1.0&q=85",
    venues: 2,
    tagline: { en: "New blood.", cz: "Čerstvá krev." },
  },
];

export const merchItems = [
  {
    id: "merch-1",
    name: "Seoul Night Hoodie",
    price: "€59",
    image:
      "https://images.unsplash.com/photo-1680292783974-a9a336c10366?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxibGFjayUyMGhvb2RpZSUyMHQtc2hpcnQlMjBtZXJjaCUyMG5lb258ZW58MHx8fHwxNzgxMTIyMTM4fDA&ixlib=rb-4.1.0&q=85",
    badge: "DROP 01",
  },
  {
    id: "merch-2",
    name: "Neon Crew Hoodie",
    price: "€65",
    image:
      "https://images.unsplash.com/photo-1572986339313-6fb01aa14717?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwzfHxibGFjayUyMGhvb2RpZSUyMHQtc2hpcnQlMjBtZXJjaCUyMG5lb258ZW58MHx8fHwxNzgxMTIyMTM4fDA&ixlib=rb-4.1.0&q=85",
    badge: "DROP 01",
  },
  {
    id: "merch-3",
    name: "K-Wave Tee",
    price: "€32",
    image:
      "https://images.unsplash.com/photo-1583244532610-2a234e7c3eca?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwxfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
    badge: "NEW",
  },
  {
    id: "merch-4",
    name: "Idol Bucket Hat",
    price: "€28",
    image:
      "https://images.unsplash.com/photo-1716969283310-51c36a9484ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzN8MHwxfHNlYXJjaHwyfHxrb3JlYW4lMjBjbHViJTIwZGolMjBuZW9uJTIwcG9zdGVyfGVufDB8fHx8MTc4MTEyMjE0NXww&ixlib=rb-4.1.0&q=85",
    badge: "LIMITED",
  },
];

export const ambassadors = [
  {
    id: "amb-1",
    name: "Mina K.",
    handle: "@mina.kpop",
    city: "Prague",
    image:
      "https://images.unsplash.com/photo-1545128485-c400e7702796?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "amb-2",
    name: "Daniel V.",
    handle: "@dan.seoulnight",
    city: "Brno",
    image:
      "https://images.unsplash.com/photo-1514525253161-7a46d19cd819?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "amb-3",
    name: "Soyeon P.",
    handle: "@soyeon.vibes",
    city: "Bratislava",
    image:
      "https://images.unsplash.com/photo-1581417478175-a9ef18f210c2?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "amb-4",
    name: "Adéla H.",
    handle: "@adi.kpop",
    city: "Prague",
    image:
      "https://images.unsplash.com/photo-1502872364588-894d7d6ddfab?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "amb-5",
    name: "Tomáš L.",
    handle: "@tomas.seoul",
    city: "Brno",
    image:
      "https://images.unsplash.com/photo-1583244532610-2a234e7c3eca?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
  {
    id: "amb-6",
    name: "Hana R.",
    handle: "@hana.kwave",
    city: "Bratislava",
    image:
      "https://images.unsplash.com/photo-1716969283310-51c36a9484ec?crop=entropy&cs=srgb&fm=jpg&w=800&q=85",
  },
];

export const HERO_VIDEO_URL = "/brand/hero.mp4";
export const HERO_VIDEO_FALLBACK =
  "https://cdn.pixabay.com/video/2021/08/21/85816-591523363_large.mp4";
